module.exports = __webpack_public_path__ + "static/kt-d250d63edce1252a0c8e43ba925c6e24.jpg";